import {
    disconnectAccountLink,
    getFintocToken,
    saveFintocUserHolder as saveFintocUserHolderApi,
} from "@/api/fintoc";

export default {
    state: () => ({}),
    mutations: {},
    actions: {
        // eslint-disable-next-line no-unused-vars
        disconnectAccountLink({ commit }, id) {
            return new Promise((resolve, reject) => {
                disconnectAccountLink(id)
                    .then(() => {
                        resolve(id);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        // Pass-throughs del widget de Fintoc (DashboardBasic): devuelven la
        // data y dejan propagar el error para que la vista conserve su manejo.
        async fetchFintocToken(_ctx, data) {
            return (await getFintocToken(data)).data;
        },
        async saveFintocUserHolder(_ctx, data) {
            return (await saveFintocUserHolderApi(data)).data;
        },
    },
    getters: {
    },
    namespaced: true,
};
